import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { userManager } from './AuthProvider';
import { sanitizeRedirectTarget } from './postLoginRedirect';

export default function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      // Default target for a failed callback (or absent/invalid state) — computed
      // up front so the `finally` below always has somewhere to send the user
      // rather than leaving them on this "Signing in…" screen.
      let target = '/';
      try {
        const user = await userManager?.signinRedirectCallback();
        // `user.state` is whatever AuthProvider passed to `signinRedirect({ state })`
        // — the deep link the user originally asked for. It round-tripped through
        // the browser and two identity providers, so treat it as untrusted and
        // validate it before ever handing it to navigate().
        target = sanitizeRedirectTarget(user?.state);
      } finally {
        navigate(target, { replace: true });
      }
    })();
  }, [navigate]);

  return <div>Signing in…</div>;
}
